import { Injectable } from '@angular/core';
import { ProductDto } from '@shared/service-proxies/service-proxies';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ShoppingCardService {

  //shoppingCards = new BehaviorSubject<ShoppingCard[]>([]);
  private itemsInCartSubject: BehaviorSubject<ProductDto[]> = new BehaviorSubject([]);
  private itemsInCart: ProductDto[] = [];

  constructor() { 

    //this.itemsInCartSubject.subscribe(_ => this.itemsInCart = _);
	
  }

  public addToCart(item: ProductDto) {

    // Sepetteki dataların kontrolü ürünId ve varyasyonId üzerinden yapılır.
    // Çünkü sepette, X ürününden birden fazla varyasyona sahip ürün olabilir. ( Bunlar SKT vb. durumlar için böyledir.)
    var current = this.itemsInCart.find(x=> x.id == item.id 
                                         && x.variationId == item.variationId);

    // Eğer sepette ilgili ürünId ve varyasyonId'ye ait bir kayıt var ise;
    if(current)
    {
      // Liste içerisinden item'a ait index numarası alınır.
      let index = this.itemsInCart.indexOf(current);
      
      // Talep miktarı sıfıra eşit ise kayıt sepetten silinir. 
      // Bunun örneği şudur; X ürününden 5 adet talep yapıldı. Sonrasında 5 adet talep miktarı silinerek 0 adete çevrildi.
      // Bu durumda x ürünün sepette durmasına gerek yoktur. Çünkü talep miktarı sıfıra olmuştur.
      if(item.orderedQty == 0){

          // Güncellenen Talep miktarı sıfır olan kayıtlar sepetten silinir.
          this.itemsInCart.splice(index,1);
      }
      else{
        // Güncellenen Talep Miktarı sepetteki kayıt ile değiştirilerek, güncel talep miktarı sepete kaydedilir.
        this.itemsInCart[index] = item;
      }
    }
    else{

      // Eğer listede parametere olarak verilen ürüne ait bir kayıt yok ve talep miktarı 0'dan büyük ise, ürün sepete eklenir.
      if(item.orderedQty > 0)
      {
        this.itemsInCart.push(item);
      }
    }
    this.itemsInCartSubject.next(this.itemsInCart);
  }
  //Bu service dışında bir component içerisinde ki aynı tipte bir behaviorsubject tutacak isek
  //bu method ile iki behaviorsubject birbirine bağlamış oluruz, böyle burada ki değişiklik, ilgili komponentteki
  //behaviorsubject içerisinde de yapılmış olur ve tam tersi de geçerlidir.
  public getItems(): BehaviorSubject<ProductDto[]> {
    return this.itemsInCartSubject;
  }

	//ortak objemiz de tuttuğumuz dataları silmek için kullanıyoruzç 
	public resetItems() {

		this.itemsInCart = [];

		return this.itemsInCartSubject.next(this.itemsInCart);
  }
 

  //kaydetme işlmelerini yaparken kullanıyoruz özellikle, daha önce kayıtlı olan ürünü sil ve o ürünü eit yeni değerleri ekle diyoruz. 
  public removeProductByProductId(productId){

     var deleteItems = this.itemsInCart.filter(x => x.id == productId);
     deleteItems.forEach(x => {
       let indexNumber = this.itemsInCart.findIndex(y => y.id == x.id);
      this.itemsInCart.splice(indexNumber,1);

     });

     return this.itemsInCartSubject.next(this.itemsInCart);
  }

  //Burası tıklanan ürüne ait varyasyonu olmayan yani modal açılmadan yazılmış datalrın hepsini temizler.
  public removeProductByVariationId(productId){

    var deleteItems = this.itemsInCart.filter(x => x.id == productId && x.variationId == 0);
     deleteItems.forEach(x => {
       let indexNumber = this.itemsInCart.findIndex(y => y.id == x.id);
      this.itemsInCart.splice(indexNumber,1);

     });

     return this.itemsInCartSubject.next(this.itemsInCart);

  }

}


